module.exports = __webpack_public_path__ + "static/media/light-theme-overspeed-alt.0b251e5b.svg";